import { render } from "./confirm.vue?vue&type=template&id=5a66b3da&scoped=true"
import script from "./confirm.vue?vue&type=script&lang=js"
export * from "./confirm.vue?vue&type=script&lang=js"

import "./confirm.vue?vue&type=style&index=0&id=5a66b3da&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a66b3da"]])

export default __exports__